var map = {
	"./ar.svg": 3918,
	"./bg.svg": 78,
	"./de.svg": 1963,
	"./en.svg": 9147,
	"./es.svg": 8995,
	"./fr.svg": 5744,
	"./hr.svg": 853,
	"./hu.svg": 6880,
	"./it.svg": 9836,
	"./nl.svg": 4729,
	"./ro.svg": 9503,
	"./ru.svg": 1233,
	"./sr.svg": 5664,
	"./tr.svg": 4143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7847;